import { render } from "./rule-item.vue?vue&type=template&id=26692e07&scoped=true&ts=true"
import script from "./rule-item.vue?vue&type=script&lang=tsx"
export * from "./rule-item.vue?vue&type=script&lang=tsx"

import "./rule-item.vue?vue&type=style&index=0&id=26692e07&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26692e07"]])

export default __exports__